/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: aeeb275c (Fri Jul 31 21:53:12 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { ProgramType } from './'

/**
 *
 * @export
 * @interface CommunityFamiliesReportRow
 */
export interface CommunityFamiliesReportRow {
  /**
   * The parent's first name.
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  parentFirstName: string
  /**
   * The parent's last name.
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  parentLastName: string
  /**
   * The parent's login email (username).
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  parentEmail: string
  /**
   * The parent's phone number.
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  parentPhone?: string
  /**
   * The student's full name (first and last).
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  studentName: string
  /**
   * The student's birth month (1-12).
   * @type number
   * @memberof CommunityFamiliesReportRow
   */
  studentBirthMonth?: number
  /**
   * The student's birth year.
   * @type number
   * @memberof CommunityFamiliesReportRow
   */
  studentBirthYear?: number
  /**
   * The enrollment status key (enrollment.enrollmentStatusKey).
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  enrollmentStatus: string
  /**
   * The date the current enrollment status took effect (enrollment.enrollmentStatusValidFrom), in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof CommunityFamiliesReportRow
   */
  enrollmentStatusDate?: Date
  /**
   * The date the student was enrolled (enrollment.enrolledDate), in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof CommunityFamiliesReportRow
   */
  enrolledDate?: Date
  /**
   *
   * @type ProgramType
   * @memberof CommunityFamiliesReportRow
   */
  programType?: ProgramType
  /**
   * Indicates if the parent has marked their profile as private.
   * @type boolean
   * @memberof CommunityFamiliesReportRow
   */
  isProfilePrivate?: boolean
  /**
   * Indicates if the parent has marked their phone number as private.
   * @type boolean
   * @memberof CommunityFamiliesReportRow
   */
  isPhoneNumberPrivate?: boolean
  /**
   * Indicates if the parent has marked their login email as private.
   * @type boolean
   * @memberof CommunityFamiliesReportRow
   */
  isLoginEmailPrivate?: boolean
  /**
   * The parent's home address, falling back to the most recent payment's billing address. Omitted if neither is on file.
   * @type string
   * @memberof CommunityFamiliesReportRow
   */
  address?: string
}

export function CommunityFamiliesReportRowFromJSON(
  json: any
): CommunityFamiliesReportRow {
  return CommunityFamiliesReportRowFromJSONTyped(json, false)
}

export function CommunityFamiliesReportRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunityFamiliesReportRow {
  if (json === undefined || json === null) {
    return json
  }
  return {
    parentFirstName: json['parentFirstName'],
    parentLastName: json['parentLastName'],
    parentEmail: json['parentEmail'],
    parentPhone: !exists(json, 'parentPhone') ? undefined : json['parentPhone'],
    studentName: json['studentName'],
    studentBirthMonth: !exists(json, 'studentBirthMonth')
      ? undefined
      : json['studentBirthMonth'],
    studentBirthYear: !exists(json, 'studentBirthYear')
      ? undefined
      : json['studentBirthYear'],
    enrollmentStatus: json['enrollmentStatus'],
    enrollmentStatusDate: !exists(json, 'enrollmentStatusDate')
      ? undefined
      : new Date(json['enrollmentStatusDate']),
    enrolledDate: !exists(json, 'enrolledDate')
      ? undefined
      : new Date(json['enrolledDate']),
    programType: !exists(json, 'programType') ? undefined : json['programType'],
    isProfilePrivate: !exists(json, 'isProfilePrivate')
      ? undefined
      : json['isProfilePrivate'],
    isPhoneNumberPrivate: !exists(json, 'isPhoneNumberPrivate')
      ? undefined
      : json['isPhoneNumberPrivate'],
    isLoginEmailPrivate: !exists(json, 'isLoginEmailPrivate')
      ? undefined
      : json['isLoginEmailPrivate'],
    address: !exists(json, 'address') ? undefined : json['address'],
  }
}

export function CommunityFamiliesReportRowToJSON(
  value?: CommunityFamiliesReportRow | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    parentFirstName: value.parentFirstName,
    parentLastName: value.parentLastName,
    parentEmail: value.parentEmail,
    parentPhone: value.parentPhone,
    studentName: value.studentName,
    studentBirthMonth: value.studentBirthMonth,
    studentBirthYear: value.studentBirthYear,
    enrollmentStatus: value.enrollmentStatus,
    enrollmentStatusDate:
      value.enrollmentStatusDate === undefined
        ? undefined
        : value.enrollmentStatusDate.toISOString().substr(0, 10),
    enrolledDate:
      value.enrolledDate === undefined
        ? undefined
        : value.enrolledDate.toISOString().substr(0, 10),
    programType: value.programType,
    isProfilePrivate: value.isProfilePrivate,
    isPhoneNumberPrivate: value.isPhoneNumberPrivate,
    isLoginEmailPrivate: value.isLoginEmailPrivate,
    address: value.address,
  }
}
